import React from "react";
import usePermissions from "hooks/usePermissions";
import SidebarNavigationLink from "components/layout/RightSidebar/SidebarNavigationLink";
import SidebarEventDefinitionDetails from "components/event-definitions/SidebarEventDefinitionDetails";
const EventDefinitionLink = ({ title, id }) => {
  const { isPermitted } = usePermissions();
  if (!title) {
    return /* @__PURE__ */ React.createElement("em", null, id);
  }
  if (isPermitted(`eventdefinitions:read:${id}`)) {
    return /* @__PURE__ */ React.createElement(SidebarNavigationLink, { content: SidebarEventDefinitionDetails(id) }, title);
  }
  return /* @__PURE__ */ React.createElement(React.Fragment, null, title);
};
export default EventDefinitionLink;
